export const COALEDU_FRONT_USERINFO = 'coaledu-front-userInfo';
export const TOKEN_KEY = 'coaledu-front-token';
export const SSO_COOKIE_NAME = 'coaledutoken';
export const CLIENT_ID = '87774aefc3b3426790df32c07ab78323';
export const siteURL = 'https://ceshi.coaledu.net/';
export const jncyURL = 'https://ceshi.coaledu.net/jncy/';
export const CC_SITEID = '15C9303902380C53';
// 暂时没用到
export const CC_PLAYERID = '5042BD877745FBF7';
export const ssoURL = `${siteURL}sso/`;
export const courseApis = `${siteURL}course/front/`;
export const BigDataCode = 'test';
export const LogAPIURL = '/collection/log';
